/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import DtoDistributionUnit from '../../../distributionUnit/dto/DtoDistributionUnit'
import DtoHydrometricStation from '../../../hydrometry/dto/DtoHydrometricStation'
import DtoInstallation from '../../../installation/dto/installation/DtoInstallation'
import DtoPiezometer from '../../../piezometry/dto/DtoPiezometer'
import { ProductionUnitShape } from '../../../productionUnit/shapes/ProductionUnitShapes'
import DtoQualitometer from '../../../quality/dto/DtoQualitometer'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import { getFullDate, getHour } from '../../../utils/DateUtil'
import { getSandreLabel } from '../../../utils/StringUtil'
import { hasValue } from '../../../utils/NumberUtil'
import StationDescriptionTable from './StationDescriptionTable'
import { Card, CardContent, Grid } from '@mui/material'
import SimpleTextArea from 'components/forms/SimpleTextArea'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import useSandreList from 'utils/customHook/useSandreList'
import { onChangeHour } from 'utils/FormUtils'
import { shallowEqual, useSelector } from 'react-redux'

const headers = ['startDate', 'endDate', 'despoliationMode', 'comment']

const DespoliationDialogContent = ({
    stateElement,
    onChangeElement = () => { },
}) => {
    const despoliationList = useSandreList(SANDRE.DESPOLIATION)

    return (
        <Card>
            <CardContent>
                <Grid container columnSpacing={1}>
                    <Grid size={6}>
                        <SimpleDatePicker
                            value={stateElement.startDate}
                            label={i18n.startDate}
                            obligatory
                            onChange={v => onChangeElement({ startDate: v })}
                            max={stateElement.endDate}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.startHour}
                            value={getHour(stateElement.startDate)}
                            onChange={v => onChangeHour(v, v2 => onChangeElement({ startDate: v2 }), { max: stateElement.endDate }, stateElement.startDate)}
                        />
                    </Grid>
                    <Grid size={6}>
                        <SimpleDatePicker
                            value={stateElement.endDate}
                            label={i18n.endDate}
                            onChange={v => onChangeElement({ endDate: v })}
                            min={stateElement.startDate}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.endHour}
                            value={getHour(stateElement.endDate)}
                            onChange={v => onChangeHour(v, v2 => onChangeElement({ endDate: v2 }), { min: stateElement.startDate }, stateElement.endDate)}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            options={despoliationList}
                            label={i18n.despoliationMode}
                            value={stateElement.despoliationMode} onChange={v => onChangeElement({ despoliationMode: `${v}` })}
                        />
                    </Grid>
                    <Grid size={12}>
                        <SimpleTextArea
                            title={i18n.comment}
                            value={stateElement.comment}
                            onChange={v => onChangeElement({ comment: v })}
                        />
                    </Grid>
                </Grid >
            </CardContent>
        </Card>
    )
}

DespoliationDialogContent.propTypes = {
    stateElement: PropTypes.object,
    onChangeElement: PropTypes.func,
}

const StationDespoliationPanel = ({
    station = {},
    readMode = false,
    onChange = () => { },
}) => {
    const {
        sandreCodes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)


    return (
        <StationDescriptionTable
            station={station}
            readMode={readMode}
            onChange={onChange}
            keyList='link_despoliationModes'
            formatFunction={c => ({
                ...c,
                startDate: getFullDate(c.startDate),
                endDate: getFullDate(c.endDate),
                despoliationMode: getSandreLabel(sandreCodes, SANDRE.DESPOLIATION, c.despoliationMode),
            })}
            titles={{
                title: i18n.despoliations,
                edit: i18n.editDespoliation,
                new: i18n.newDespoliation,
            }}
            headers={headers}
            dialogContent={DespoliationDialogContent}
            isValidElement={el => hasValue(el.startDate)}
        />
    )
}

StationDespoliationPanel.propTypes = {
    station: PropTypes.oneOfType([
        ProductionUnitShape,
        PropTypes.instanceOf(DtoDistributionUnit),
        PropTypes.instanceOf(DtoQualitometer),
        PropTypes.instanceOf(DtoPiezometer),
        PropTypes.instanceOf(DtoHydrometricStation),
        PropTypes.instanceOf(DtoInstallation),
    ]),
    readMode: PropTypes.bool,
    onChange: PropTypes.func,
}

export default StationDespoliationPanel